export default __webpack_public_path__ + "static/media/img12.67d3b989.PNG";